import { ApiEndpoints } from 'models/api';
import { StaffingGridItem } from 'pages/Anesthesia/components';
import { standardApi } from 'store/api';

import { RoomTurnoverResponse } from './CoreService';

const filterApi = standardApi.enhanceEndpoints({ addTagTypes: ['Notifications'] });

export interface DailyExportData {
	name: string;
	date: string;
	healthsystem_name: string;
	prime_time_start: string;
	prime_time_end: string;
	rooms_count: string;
	primetime_utilization: number;
	avg_out_in_wheels_turnover: number;
	fcots_start_percentage: number;
	case_volume: number;
	scheduled_cases: number;
	same_day_canceled_cases: number;
	avg_delay_first_case: number;
	avg_procedure_stop_start_turnover: number;
	number_of_addons: number;
	timeline: RoomTurnoverResponse;
}

/**
 * Provides endpoints for data values in database
 */
export const pdfService = filterApi.injectEndpoints({
	endpoints: (build) => ({
		getDailyExportData: build.query<{ responses: DailyExportData[] }, { token: string }>({
			query: (body) => ({
				url: `${ApiEndpoints.DAILY_OR_EXPORT}?token=${body.token}`,
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const { useGetDailyExportDataQuery } = pdfService;

export const {
	endpoints: { getDailyExportData },
} = pdfService;
